import { useAdaptiveRtStore } from '@/stores/adaptiveRtStore';
import { usePlanStore } from '@/stores/planStore';
import { clearPersistedHistorySessionContext } from '@/composables/clearHistorySessionContext';

/**
 * Сброс клиентского состояния расчёта при смене курса (новый курс / другой курс).
 * Иначе в AdaptiveRT и standard остаются ГДО, d/nf и черновики прошлой сессии.
 */
export function resetCourseWorkflowState() {
  useAdaptiveRtStore().clear();
  const planStore = usePlanStore();
  planStore.clearSelectedPlanId();
  planStore.clearFractionationDraft();
  planStore.fractionationByPlanId = {};
  clearPersistedHistorySessionContext();
}
